import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguageStore } from '../../store/languageStore';
import { useUiStore } from '../../store/uiStore';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { Toaster } from 'react-hot-toast';

export const Layout: React.FC = () => {
  const { i18n } = useTranslation();
  const { language, isRTL } = useLanguageStore();
  const { sidebarCollapsed } = useUiStore();

  useEffect(() => {
    i18n.changeLanguage(language);
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language, isRTL, i18n]);

  const sidebarWidth = sidebarCollapsed ? '80px' : '280px';

  return (
    <div 
      className="min-vh-100 d-flex"
      style={{
        background: 'linear-gradient(to bottom right, #f9fafb, #ffffff, #f9fafb)',
        overflowX: 'hidden'
      }}
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <Sidebar />
      <motion.div 
        className="flex-grow-1"
        style={{
          maxWidth: '100%',
          overflowX: 'hidden'
        }}
        animate={{
          marginLeft: isRTL ? '0' : sidebarWidth,
          marginRight: isRTL ? sidebarWidth : '0',
          width: `calc(100% - ${sidebarWidth})`,
        }}
        transition={{
          type: 'spring',
          stiffness: 300,
          damping: 30,
        }}
      >
        <Header />
        <motion.main
          className="p-4"
          style={{ 
            minHeight: 'calc(100vh - 64px)',
            width: '100%',
            maxWidth: '100%',
            overflowX: 'hidden'
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3 }}
        >
          <Outlet />
        </motion.main>
      </motion.div>
      
      {/* Toast notifications */}
      <Toaster
        position={isRTL ? 'top-left' : 'top-right'}
        toastOptions={{
          duration: 3000,
          style: {
            background: '#fff',
            color: '#1f2937',
            borderRadius: '12px',
            boxShadow: '0 10px 40px -10px rgba(0, 0, 0, 0.2)',
            padding: '16px',
          },
          success: {
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
          },
          error: {
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
    </div>
  );
};
